import { printHtmlNodesToText, printHtmlNodesToJsx, generateJsxKey } from '@utils/ast';
import { PM2IGuideComponent } from './comp.root.js';
import { jsx } from 'react/jsx-runtime';

const printIGuideComponent = (node, context) => {
  return /*#__PURE__*/jsx(PM2IGuideComponent, {
    learningObjectId: node.pm2.learningObjectId,
    learningObjectTitle: node.pm2.learningObjectTitle,
    component: node.component,
    displayMode: node.options.displayMode,
    isScrambled: node.pm2.isScrambled,
    previewImage: node.meta.previewImage,
    indexOrLevel: node.meta.indexOrLevel,
    richtextDescription: printHtmlNodesToJsx(node.meta.richTextDescription),
    lightboxDescription: printHtmlNodesToText(node.meta.lightboxDescription ?? []),
    node: node,
    onResetEntry: undefined
  }, generateJsxKey(context));
};
const iGuideComponentJsxPrinters = {
  "component-framework.i-guide": printIGuideComponent
};

export { iGuideComponentJsxPrinters, printIGuideComponent };
//# sourceMappingURL=printer.to-jsx.js.map
